import React, { FC, useMemo } from 'react'
import { observer } from 'mobx-react'
import { RouteComponentProps } from 'react-router-dom'
import { IonPage, IonContent, useIonViewWillEnter } from '@ionic/react'
import { GetCardItem, MktEmpty } from '@cps'
import { memberMobx, memberCardMobx } from '@mobxStore'
import { find } from '@dt/fe-utils/dist/lodash'
import { useHistoryNew } from '@utils'
import { MktHeader } from 'pages/mkt/components'
import mktController from 'controllers/mktController'
import './index.scss'

import noMemberCardImg from '@img/no-membercard.png'

interface IProps extends IPage, RouteComponentProps {
}

const CardApply: FC<IProps> = () => {
  const history = useHistoryNew()
  const _noHasCards = useMemo(() => {
    const getCardArr: any[] = memberCardMobx.cardList.filter((item: any) => {
      const hasItem: any = find(memberMobx.cardList, (m: any) => m.cardId === item.cardId)
      return !hasItem
    })
    return getCardArr
  }, [memberCardMobx.cardList, memberMobx.cardList])
  useIonViewWillEnter(() => {
    memberCardMobx.cardList.length === 0 && memberCardMobx.getCardList()
    memberMobx.cardList.length === 0 && memberMobx.getMemberCards()
  })
  return (
    <IonPage className='apply-card-page'>
      <MktHeader onBack={() => mktController.goBack(history)} title={i18n.t('mkt.member.applyCard')}></MktHeader>
      <IonContent className='page-content'>
        {
          _noHasCards.length > 0
            ? (
              <div className='card-list'>
                {
                  _noHasCards.map((item: any) => {
                    return (
                      <div className='get-card-blcok' key={item.cardId}>
                        <GetCardItem cardInfo={item} isHas={false} hasDetail={false} />
                      </div>
                    )
                  })
                }
              </div>)
            : <MktEmpty img={noMemberCardImg} text={i18n.t('mkt.member.noCardTip')}></MktEmpty>
        }
      </IonContent>
    </IonPage>
  )
}

export default observer(CardApply)
